import { render, staticRenderFns } from "./GBRightPaneProjectPenned.vue?vue&type=template&id=2e7c468f&"
import script from "./GBRightPaneProjectPenned.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneProjectPenned.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneProjectPenned.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VForm,VLayout})
